export const REGANTO_CLASSIC_REQUEST = "REGANTO_CLASSIC_REQUEST";
export const REGANTO_CLASSIC_SUCCESS = "REGANTO_CLASSIC_SUCCESS";
export const REGANTO_CLASSIC_FAILED = "REGANTO_CLASSIC_FAILED";
